import React, { useEffect, useState } from "react";
import { TreeSelect } from "antd";
import useRequest from "@/utils/useRequest";
import _ from "lodash";

function list_to_tree(list) {
    var map = {}, node, roots = [], i;
    var ids = new Set(); // 用于存储所有节点Id

    // 遍历一遍列表，获取所有节点的Id
    for (i = 0; i < list.length; i += 1) {
        ids.add(list[i].Id);
    }

    // 遍历列表，构建树形结构
    for (i = 0; i < list.length; i += 1) {
        map[list[i].Id] = i; // initialize the map
        list[i].key = list[i].Id;
        list[i].title = list[i].Name;
        list[i].value = list[i].Id;
        list[i].children = []; // initialize the children

        // 检查父节点是否存在于ids集合中，如果不存在则将该节点作为根节点处理
        if (list[i].Pid !== -1 && !ids.has(list[i].Pid)) {
            roots.push(list[i]);
        }
    }

    // 再次遍历列表，构建树形结构
    for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.Pid !== -1 && ids.has(node.Pid)) {
            list[map[node.Pid]].children.push(node);
        } else if (node.Pid === -1) {
            roots.push(node);
        }
    }

    return roots;
}

const EntityDeptTreeSelect = ({ value, onChange, className, multiple = false }) => {
    const [loading, setLoading] = useState(false);
    const [gData, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]); // 保存原始数据用于查找完整实体
    const { request } = useRequest();

    const Refresh = async () => {
        setLoading(true);
        const result = await request('/api/v2/private/dept/all', "POST", "json", {
            filters: {},
            pagination: { current: 1, pageSize: 1000 }
        });
        if (result.success) {
            // 保存原始数据
            setOriginalData(result.data);
            // 组装成树形结构
            let tree = list_to_tree(_.sortBy(result.data, "Left"));
            setLoading(false);
            setData(tree);
        }
    };

    useEffect(() => {
        Refresh();
    }, []);

    const findDeptById = (id) => {
        return originalData.find(dept => dept.Id === id);
    };

    const handleChange = (selectedValues) => {
        if (onChange) {
            if (multiple) {
                // 多选模式：返回完整的部门实体数组
                const entities = Array.isArray(selectedValues) ? selectedValues.map(id => {
                    const deptData = findDeptById(id);
                    return deptData ? {
                        Id: deptData.Id,
                        Name: deptData.Name,
                        Pid: deptData.Pid,
                        Code: deptData.Code,
                        Description: deptData.Description,
                        Left: deptData.Left,
                        Right: deptData.Right
                    } : null;
                }).filter(Boolean) : [];
                onChange(entities);
            } else {
                // 单选模式：返回完整的部门实体对象
                const deptData = findDeptById(selectedValues);
                const entity = deptData ? {
                    Id: deptData.Id,
                    Name: deptData.Name,
                    Pid: deptData.Pid,
                    Code: deptData.Code,
                    Description: deptData.Description,
                    Left: deptData.Left,
                    Right: deptData.Right
                } : null;
                onChange(entity);
            }
        }
    };

    // 处理value显示：如果value是实体对象，需要转换为ID用于TreeSelect组件
    const getDisplayValue = () => {
        if (!value) return undefined;
        
        if (multiple) {
            return Array.isArray(value) ? value.map(item => 
                typeof item === 'object' ? item.Id : item
            ) : [];
        } else {
            return typeof value === 'object' ? value.Id : value;
        }
    };

    return (
        <TreeSelect
            className={className || "w-full"}
            placeholder="请选择部门..."
            multiple
            value={getDisplayValue()}
            treeDefaultExpandAll
            onChange={handleChange}
            treeData={gData}
            loading={loading}
        />
    );
};

export default EntityDeptTreeSelect;